<ng-container *ngrxLet="commercialStore.isFetchingInvitations$ as isFetchingInvitations">
  <div *ngIf="!isFetchingInvitations">
    <ng-container *ngrxLet="commercialStore.fetchedInvitations$ as fetchedInvitations">
      <ng-container
        *ngrxLet="
          authStore.isUserOfCommercialOwnerCompanyWithRoleInvitation$ as isUserOfCommercialOwnerCompanyWithRoleInvitation
        "
      >
        <div class="parter-tiles-wrapper">
          <ng-container *ngIf="fetchedInvitations.length > 0">
            <ng-container *ngFor="let invitation of fetchedInvitations">
              <app-partner-access-settings-item
                *ngIf="invitationVisibility(invitation)"
                [invitation]="invitation"
                (deleteInvitation)="removePartner(invitation)"
                (hideInvitation)="hidePartnerInvitation(invitation)"
              ></app-partner-access-settings-item>
            </ng-container>
          </ng-container>

          <div *ngIf="isUserOfCommercialOwnerCompanyWithRoleInvitation" class="grow-item">
            <div class="share-device-monitoring flex flex-col justify-between items-start">
              <p class="share-device-monitoring__title">
                {{
                  '+INSTALLATIONS.INSTALLATION.DEVICE_CARD.SHARE_DEVICE_MONITORING.BUTTON'
                    | translate
                }}
              </p>
              <button
                class="share-device-monitoring__btn"
                mat-stroked-button
                color="primary"
                (click)="openShareDeviceMonitoringDialog()"
              >
                {{
                  '+INSTALLATIONS.PARTNER_ACCESS.SETTINGS_OVERLAY.ADD_NEW_PARTICIPANT' | translate
                }}
              </button>
            </div>
          </div>
        </div>
        <app-banner
          *ngIf="
            fetchedInvitations.length === 0 && !isUserOfCommercialOwnerCompanyWithRoleInvitation
          "
        >
          {{ '+INSTALLATIONS.PARTNER_ACCESS.EMPTY_PARTNER' | translate }}
        </app-banner>
      </ng-container>
    </ng-container>
  </div>
  <vi-loader
    data-at-loader
    *ngIf="isFetchingInvitations"
    message="{{
      'INSTALLATIONS.INSTALLATION.DEVICE_CARD.SHARE_DEVICE_MONITORING.FETCHING_INVITATIONS'
        | translate
    }}"
    [isLoading]="true"
  ></vi-loader>
</ng-container>
